<template>
  <el-form size="small" :inline="true" class="demo-form-inline">
    <el-form-item :label="$t('message.name')">
      <el-autocomplete
        v-model="person_id"
        :fetch-suggestions="querySearchAsync"
        @select="changeForm"
      ></el-autocomplete>
    </el-form-item>

    <el-form-item :label="$t('message.phone')">
      <el-input v-model="phone_number" @input="changeForm" clearable>
      </el-input>
    </el-form-item>

    <el-form-item :label="$t('message.identity_card')">
      <el-input v-model="id_number" @input="changeForm" clearable>
      </el-input>
    </el-form-item>
  </el-form>
</template>

<script>
  // @ is an alias to /src
  export default {
    name: 'SinglePersonFilter',
    data () {
      return {
        name: '',
        phone_number: '',
        id_number: '',
      }
    },
    components: {},
    props: [
      'default_id_number',
    ],
    mounted () {
      this.id_number = this.default_id_number
    },
    methods: {
      querySearchAsync(queryString, cb) {
        this.axios.get(`/admin/org/suggestion`, {
        params: { name: queryString, limit: 8 }
      }).then(response => {
        cb(response.data.data.list.map(org => {
          org.org_id = org.id
          org.org_type = org.type
          return org
        }))
      }).catch(error => {
        console.log(cb);
      })
      },
      changeForm () {
        this.$emit('filterChange', {
          name: this.name,
          phone_number: this.phone_number,
          id_number: this.id_number
        })
      }
    }
  }
</script>

<style lang="less">
</style>
